
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.516 2.615L2.77 10.361a2.163 2.163 0 00.321 3.007l5.84 5.839a2.163 2.163 0 003.006.32l7.746-7.745c.352-.363.527-.863.476-1.366l-.403-5.5a2.658 2.658 0 00-2.374-2.374l-5.5-.403a1.714 1.714 0 00-1.366.476zm4.446 6.031c-.347 0-.678-.142-.917-.393a1.265 1.265 0 010-1.834 1.296 1.296 0 111.834 1.834c-.24.25-.57.393-.917.393z","fill":"#fff"}})])
          )
        }
      }
    